module.exports = __webpack_public_path__ + "media/images/bg/loop-acfde4e6da0c251ff16ac962f89e6330.svg";